import { useSession } from '../hooks/useSession';
import SetupForm from '../components/setup/SetupForm';

export default function SetupPage() {
  const { startSession, isLoading, error, clearError } = useSession();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="text-6xl mb-4">🍺</div>
          <h1 className="text-3xl font-bold text-beer">Optimální Promile</h1>
          <p className="text-gray-400 mt-2">
            Sledujte svou hladinu alkoholu v reálném čase
          </p>
        </div>

        {/* Error message */}
        {error && (
          <div className="mb-6 p-4 bg-red-900/50 border border-red-700 rounded-lg flex items-center justify-between">
            <span className="text-red-200">{error}</span>
            <button
              onClick={clearError}
              className="text-red-400 hover:text-red-200"
            >
              ✕
            </button>
          </div>
        )}

        {/* Setup form */}
        <div className="bg-gray-800 rounded-2xl p-6 shadow-xl">
          <SetupForm onSubmit={startSession} isLoading={isLoading} />
        </div>

        {/* Disclaimer */}
        <p className="text-center text-xs text-gray-500 mt-6 px-4">
          Tato aplikace slouží pouze pro informativní účely. Hodnoty BAC jsou
          pouze odhady a mohou se lišit od skutečných hodnot. Nikdy neřiďte
          pod vlivem alkoholu.
        </p>
      </div>
    </div>
  );
}
